export default {
  methods:{
    performAutoLogin: function(token){ // 토큰이 로컬스토리지에 담겼을 시 사용
      this.$api.$handler.authHeader(token);
    },
    localLogout: function(token){ // 토큰이 로컬스토리지에 담겼을 시 사용
      this.$localStorage.clear(true);
      this.$route.query.first = false;
      this.$router.push({path: "/auth", query: {logout: true}});
    }
  }
}
